export function toggleFilterValue(prevFilters, filterType, value) {
  const currentFilter = prevFilters[filterType] || [];
  const updatedFilter = currentFilter.includes(value)
    ? currentFilter.filter(item => item !== value)
    : [...currentFilter, value];
  return { ...prevFilters, [filterType]: updatedFilter };
}
